import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core'

@Component({
  selector: 'app-action-toolbar',
  templateUrl: './action-toolbar.component.html',
  styleUrls: ['./action-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ActionToolbarComponent {
  @Input() canSave = false

  @Input() canDiscard = false

  @Input() isLoading: boolean

  @Input() hideButtons: boolean

  @Output() delete = new EventEmitter<never>()

  @Output() save = new EventEmitter<never>()

  @Output() discard = new EventEmitter<never>()

  onDelete(): void {
    this.delete.emit()
  }

  onSave(): void {
    this.save.emit()
  }

  onDiscard(): void {
    this.discard.emit()
  }
}
